var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"m-2 text-center"},[_c('b-spinner'),_vm._m(0)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1"},[_c('small',[_vm._v("Yükleniyor..")])])}]

export { render, staticRenderFns }